import React from 'react';
import chair from '../../../assets/images/chair.png';
import bg from '../../../assets/images/bg.png';

const Banner = () => {
    return (
        <div style={{
            background: `url(${bg})`,
            backgroundSize: 'cover'
        }} className="hero">
            <div className="hero-content flex-col lg:flex-row-reverse">
                <img src={chair} className="rounded-lg lg:w-1/2 shadow-2xl" alt='' />
                <div>
                    <h1 className="text-5xl font-bold">Dental Doctor's News!</h1>
                    <p className="py-6">In addition to the navigation, more icons highlight specialty services, smile galleries, and emergency dentistry. Clear calls to action encourage patients to schedule appointments or download new patient forms.</p>
                    <button
                        className="btn btn-primary bg-gradient-to-r from-primary to-secondary text-white">Getting Started</button>
                </div>
            </div>
        </div>
    );
};

export default Banner;